var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0937 10.6875C12.5974 10.1875 11.3956 9.45781 10.8124 9.16375C10.0531 8.78125 9.99056 8.75 9.39369 9.19344C8.99556 9.48938 8.73087 9.75375 8.26494 9.65438C7.799 9.555 6.7865 8.99469 5.89993 8.11094C5.01337 7.22719 4.42056 6.18531 4.32087 5.72094C4.22118 5.25656 4.48993 4.995 4.78306 4.59594C5.19618 4.03344 5.16493 3.93969 4.81181 3.18031C4.5365 2.58969 3.78556 1.39906 3.28368 0.905313C2.74681 0.375001 2.74681 0.468751 2.40087 0.612501C2.11924 0.730997 1.84905 0.875036 1.59368 1.04281C1.09368 1.375 0.816185 1.65094 0.622122 2.06563C0.42806 2.48031 0.340872 3.4525 1.34306 5.27313C2.34525 7.09375 3.04837 8.02469 4.50368 9.47594C5.959 10.9272 7.07806 11.7075 8.714 12.625C10.7377 13.7584 11.514 13.5375 11.9299 13.3438C12.3459 13.15 12.6231 12.875 12.9559 12.375C13.1241 12.1201 13.2684 11.8502 13.3871 11.5688C13.5312 11.2241 13.6249 11.2241 13.0937 10.6875Z",
    stroke: "#E46869",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.733ec309e12fcc41757f01ddde05b065.svg";
export { ForwardRef as ReactComponent };